export default __webpack_public_path__ + "static/media/tag-fill.2036e0d2.svg";